import React from 'react';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import { BLACK, GRAY } from '../../../../../styles/constants/color';
import { fontFrame } from '../../../../../styles/mixin/font';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import { otherBankPaymentTypeInfoState } from '../../../../../data/estimate/common/otherBank/info/atom';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';

const Select = styled.select`
  width: 60px;
  height: 25px;
  border: 1px solid ${GRAY};
  ${fontFrame('400', '11px', '1', BLACK)};
  -webkit-appearance: none;
`;

/**
 *  타금융사 할부조건 가용금액 셀렉트 로직 컴포넌트
 *  */
function OtherBankPaymentType(): JSX.Element {
  // selected
  const paymentType: string[] = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPaymentType' })
  );

  // function
  const update = useUpdateInfo(otherBankPaymentTypeInfoState);
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>): void => update(e.target.value);
  return (
    <Select value={paymentType} onChange={onChange}>
      <option value='availableAmount'>가용금액</option>
      <option value='untilRegistration'>등록까지</option>
      <option value='untilRelease'>출고까지</option>
      <option value='deliveryMoneyWithConsignmentPrice'>인도(+탁송)</option>
      <option value='deliveryMoneyWithoutConsignmentPrice'>인도(-탁송)</option>
    </Select>
  );
}

export default OtherBankPaymentType;
